var _defs, _g, _path, _path2, _path3, _path4, _g2, _g3, _g4, _g5;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomLink(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45,
    zoomAndPan: "magnify",
    viewBox: "0 0 33.75 33.749998",
    height: 45,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dcca20ef74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.042969 1.042969 L 33.054688 1.042969 L 33.054688 33.054688 L 1.042969 33.054688 Z M 1.042969 1.042969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4907928c50"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 33.5 0 L 33.5 3.351562 L 0 3.351562 Z M 0 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3da9724dd0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 30.152344 L 33.5 30.152344 L 33.5 33.5 L 0 33.5 Z M 0 30.152344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1535bacd3f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 29 0 L 33.5 0 L 33.5 33.5 L 29 33.5 Z M 29 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fd754f8e36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 35.316406 -3.375 L 36.363281 35.546875 L 30.816406 35.695312 L 29.769531 -3.226562 Z M 35.316406 -3.375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "92d7b61909"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 5 0 L 5 33.5 L 0 33.5 Z M 0 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fc1ca7b5b8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3.398438 -2.773438 L 4.222656 36.152344 L -1.324219 36.269531 L -2.148438 -2.65625 Z M 3.398438 -2.773438 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dcca20ef74)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 7.125 1.042969 L 26.972656 1.042969 C 27.371094 1.042969 27.769531 1.082031 28.160156 1.160156 C 28.550781 1.238281 28.929688 1.351562 29.300781 1.503906 C 29.667969 1.65625 30.019531 1.84375 30.351562 2.066406 C 30.683594 2.289062 30.992188 2.542969 31.273438 2.824219 C 31.554688 3.105469 31.808594 3.414062 32.03125 3.746094 C 32.25 4.078125 32.4375 4.429688 32.59375 4.796875 C 32.746094 5.167969 32.859375 5.546875 32.9375 5.9375 C 33.015625 6.328125 33.054688 6.726562 33.054688 7.125 L 33.054688 26.972656 C 33.054688 27.371094 33.015625 27.769531 32.9375 28.160156 C 32.859375 28.550781 32.746094 28.929688 32.59375 29.300781 C 32.4375 29.667969 32.25 30.019531 32.03125 30.351562 C 31.808594 30.683594 31.554688 30.992188 31.273438 31.273438 C 30.992188 31.554688 30.683594 31.808594 30.351562 32.03125 C 30.019531 32.25 29.667969 32.4375 29.300781 32.59375 C 28.929688 32.746094 28.550781 32.859375 28.160156 32.9375 C 27.769531 33.015625 27.371094 33.054688 26.972656 33.054688 L 7.125 33.054688 C 6.726562 33.054688 6.328125 33.015625 5.9375 32.9375 C 5.546875 32.859375 5.167969 32.746094 4.796875 32.59375 C 4.429688 32.4375 4.078125 32.25 3.746094 32.03125 C 3.414062 31.808594 3.105469 31.554688 2.824219 31.273438 C 2.542969 30.992188 2.289062 30.683594 2.066406 30.351562 C 1.84375 30.019531 1.65625 29.667969 1.503906 29.300781 C 1.351562 28.929688 1.238281 28.550781 1.160156 28.160156 C 1.082031 27.769531 1.042969 27.371094 1.042969 26.972656 L 1.042969 7.125 C 1.042969 6.726562 1.082031 6.328125 1.160156 5.9375 C 1.238281 5.546875 1.351562 5.167969 1.503906 4.796875 C 1.65625 4.429688 1.84375 4.078125 2.066406 3.746094 C 2.289062 3.414062 2.542969 3.105469 2.824219 2.824219 C 3.105469 2.542969 3.414062 2.289062 3.746094 2.066406 C 4.078125 1.84375 4.429688 1.65625 4.796875 1.503906 C 5.167969 1.351562 5.546875 1.238281 5.9375 1.160156 C 6.328125 1.082031 6.726562 1.042969 7.125 1.042969 Z M 7.125 1.042969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.370519, 0, 0, 0.370519, 3.710019, 3.710017)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 18.32558 69.067294 C 15.44744 69.067294 12.548215 68.223883 10.00744 66.463263 L 9.480308 66.094271 C 2.859533 61.497681 1.214881 52.378301 5.811471 45.768068 L 19.738293 27.1814 C 21.920619 24.039694 25.262635 21.888997 29.100154 21.193183 C 32.937674 20.507911 36.817364 21.351322 40.022326 23.575818 L 40.56 23.944811 C 43.28 25.831943 45.293644 28.615199 46.231938 31.799075 C 46.548218 32.853338 45.936745 33.970858 44.882481 34.276594 C 43.828217 34.592873 42.710698 33.991943 42.394419 32.927137 C 41.709148 30.586672 40.285892 28.615199 38.282791 27.234113 L 37.745116 26.865121 C 35.415194 25.241555 32.60031 24.630082 29.817054 25.136129 C 27.023255 25.631632 24.598449 27.191943 22.985425 29.521865 L 9.058603 48.108533 C 5.758758 52.852719 6.960618 59.473495 11.757518 62.804968 L 12.295192 63.184503 C 17.092092 66.515976 23.712867 65.324658 27.054883 60.517216 L 31.303565 54.391944 C 31.936124 53.485278 33.180155 53.263882 34.086821 53.89644 C 34.993488 54.528999 35.225426 55.77303 34.592868 56.679696 L 30.333643 62.804968 C 27.508216 66.884968 22.943255 69.067294 18.32558 69.067294 Z M 18.32558 69.067294 ",
    stroke: "#ffffff",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.370519, 0, 0, 0.370519, 3.710019, 3.710017)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 40.296434 51.039386 C 37.418295 51.039386 34.508527 50.195975 31.978294 48.435355 L 31.44062 48.066363 C 28.72062 46.179231 26.706976 43.385432 25.768681 40.212099 C 25.452402 39.157835 26.063875 38.040315 27.118139 37.734579 C 28.182945 37.4183 29.289922 38.01923 29.606201 39.084036 C 30.291472 41.413959 31.714728 43.385432 33.717829 44.77706 L 34.255504 45.156595 C 39.052403 48.488068 45.683721 47.29675 49.015194 42.489308 L 62.942017 23.90264 C 66.241862 19.158454 65.040002 12.537678 60.243102 9.195662 L 59.71597 8.837213 C 57.375505 7.213647 54.560621 6.602174 51.777365 7.10822 C 48.994109 7.603724 46.55876 9.164034 44.945737 11.493957 L 40.697054 17.619229 C 40.064496 18.525896 38.820465 18.747291 37.913798 18.114733 C 37.007132 17.492717 36.775194 16.238143 37.407752 15.331477 L 41.666977 9.206205 C 43.891473 6.001244 47.222946 3.861088 51.071009 3.165274 C 54.908528 2.480003 58.788218 3.323414 61.99318 5.54791 L 62.520312 5.90636 C 69.141087 10.513492 70.785739 19.632872 66.189149 26.243105 L 52.262326 44.829773 C 49.457985 48.867603 44.914109 51.039386 40.296434 51.039386 Z M 40.296434 51.039386 ",
    stroke: "#ffffff",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.370519, 0, 0, 0.370519, 3.710019, 3.710017)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 52.75783 33.106362 C 52.546978 33.106362 52.336125 33.043106 52.1569 32.906052 C 51.714109 32.57923 51.629768 31.946672 51.95659 31.503881 L 52.504807 30.776439 C 52.842171 30.333648 53.464187 30.249307 53.906978 30.576129 C 54.349768 30.902951 54.444652 31.535509 54.107288 31.9783 L 53.559071 32.705741 C 53.358761 32.969307 53.063567 33.106362 52.75783 33.106362 Z M 52.75783 33.106362 ",
    stroke: "#ffffff",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.370519, 0, 0, 0.370519, 3.710019, 3.710017)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 55.045582 30.05954 C 54.83473 30.05954 54.623877 29.985741 54.444652 29.85923 C 54.001861 29.521865 53.91752 28.89985 54.244342 28.457059 L 58.672249 22.553183 C 59.737056 21.0245 60.148218 19.137368 59.810854 17.271322 C 59.47349 15.405275 58.429769 13.781709 56.869459 12.695818 L 56.532094 12.46388 C 56.068218 12.147601 55.962792 11.525585 56.279071 11.072252 C 56.584807 10.618918 57.206823 10.502949 57.670699 10.819228 L 58.008063 11.061709 C 60.011164 12.442794 61.339536 14.530236 61.771784 16.912872 C 62.204033 19.306051 61.676901 21.730857 60.295815 23.723415 L 55.846823 29.65892 C 55.646513 29.922485 55.351319 30.05954 55.045582 30.05954 Z M 55.045582 30.05954 ",
    stroke: "#ffffff",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4907928c50)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M -2.570312 -2.195312 L 36.363281 -2.195312 L 36.363281 3.351562 L -2.570312 3.351562 Z M -2.570312 -2.195312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3da9724dd0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 0 30.152344 L 38.933594 30.152344 L 38.933594 35.699219 L 0 35.699219 Z M 0 30.152344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1535bacd3f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fd754f8e36)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 35.316406 -3.375 L 36.363281 35.542969 L 30.816406 35.691406 L 29.769531 -3.226562 Z M 35.316406 -3.375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#92d7b61909)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fc1ca7b5b8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 3.398438 -2.773438 L 4.222656 36.148438 L -1.324219 36.265625 L -2.148438 -2.65625 Z M 3.398438 -2.773438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomLink);
export default __webpack_public_path__ + "static/media/customLink.b3a41b8021db68f8cf503dd38468a591.svg";
export { ForwardRef as ReactComponent };